import Icon from '../components/Icon.vue'

Icon.register({
  khanda: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M415.8 66c73.7 40.2 111.8 123.8 90.2 207.5-7.3 28.1-22.4 53.6-41.3 75.6l-52.5 61.3c-4.9 5.7-13 7.2-19.7 3.7l-79.3-42.2-29.2 20.3 47.1 32.8c1.7-0.4 3.2-1 5-1 13.3 0 24 10.7 24 24 0 13.3-10.7 24-24 24-12.1 0-21.7-9.1-23.3-20.8l-40.9-28.5v30.2c9.4 5.6 16 15.4 16 27.1 0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32 0-11.7 6.6-21.5 16-27.1v-30l-40.6 28.3c-1.6 11.6-11.2 20.8-23.3 20.8-13.3 0-24-10.8-24-24 0-13.3 10.7-24 24-24 1.8 0 3.3 0.6 5 1l47.1-32.8-29.2-20.3-79.3 42.2c-6.6 3.5-14.8 2-19.7-3.7l-56-65.4c-12.6-14.7-23.4-31.1-30.5-49.1-35.7-90.7 3-186.4 81.5-229.2 6.3-3.5 15-2.6 20 2.7 5 5.3 6.5 12.9 2.6 19.1-16.5 26.2-25.2 56.4-25.2 87.5 0.2 53.2 26.8 102.6 71 132.2l76.6 53.3v-19.9l-44-36.1c-3.9-4.2-5-10.1-2.8-15.3l7.9-17.2c-33.9-19.3-56.9-55.2-56.9-97 0-40.8 22-76.1 54.6-95.7l-5.2-11.4c-2.3-5.5-0.9-11.8 3.6-16l59-52.8 59 52.8c4.5 4.2 5.9 10.5 3.6 16l-5.2 11.4c32.6 19.6 54.6 54.9 54.6 95.7 0 41.7-23.1 77.7-56.9 97l7.9 17.2c2.2 5.2 1.1 11.1-2.8 15.3l-44 36.1v20.1l76.6-53.3c44.5-29.7 71.1-79.2 71.3-132.4 0-31-8.7-61.3-25.2-87.4-1.4-2.2-2.5-6-2.5-8.5 0-3.5 2-8.4 4.4-11 5-5.3 13-6.5 19.4-3zM319.8 176c0-21.3-10.6-40.1-26.7-51.8l-7.8 17.2c-8.8 24.5-8.8 51 0 75.6l5.7 12.4c17.3-11.5 28.8-31.1 28.8-53.4zM191.9 176c0 22.3 11.5 41.9 28.8 53.4l5.6-12.4c8.8-24.5 8.8-51 0-75.6l-7.8-17.2c-16.1 11.6-26.7 30.4-26.7 51.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/khanda.js
// module id = 1500
// module chunks = 0